import React, { useState, useEffect } from "react";
import { Tabs, Radio, Button, Spin, Select } from "antd";

const { Option } = Select;
import classNames from "classnames";
import map from "../assets/orange-map.png";
import aslkahawaii from "../assets/aslkahawaii.png";
import axios from "axios";
import { useAppContext } from "../AppContext";

const { TabPane } = Tabs;

const Tab = () => {
  const [selectedOption, setSelectedOption] = useState("state");
  const [activeTab, setActiveTab] = useState("state");
  const [count, setCount] = useState();
  const {selectedState, setSelectedState, selectedStateName, setSelectedStateName, zipcodes, setZipcodes, selectedMetro, setSelectedMetro} = useAppContext();
  
  // Use selectedMetro from context, but keep local reference for easier refactoring
  const selected = selectedMetro;
  const setSelected = setSelectedMetro;
console.log(selectedStateName,'seledctedsdsd');

  const tabs = [
    { key: "state", label: "By State" },
    { key: "metro", label: "By Metro" },
    { key: "details", label: "List Details" },
  ];

  const [options, setOptions] = useState([]);
  const [metroStateOptions, setMetroStateOptions] = useState([]);
  const [stateOption, setStateOption] = useState([]);
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ip, setIp] = useState();
  const [isAutoSelected, setIsAutoSelected] = useState(false); // Track if state auto-selection has happened
  const [userChangedState, setUserChangedState] = useState(false); // Track if user manually changed state
  const [userSelectedMetro, setUserSelectedMetro] = useState(false); // Track if user manually selected metro
  const [shouldAutoSelectMetro, setShouldAutoSelectMetro] = useState(false); // Track if metro should be auto-selected

  useEffect(() => {
    const getIpDetails = async () => {
      try {
        // Make a request without the token
        const response = await axios.get("https://ipinfo.io/json");
        setIp(response.data);
      } catch (error) {
        console.error("Error fetching IP details:", error);
      }
    };

    getIpDetails();
  }, []);
  console.log(ip?.region,'ip');
  console.log(selectedState,'selectedstatess');
  

  // Fetch metro options based on selected state
  useEffect(() => {
    const fetchMetroOptions = async () => {
      try {
        const stateAbbr = selectedState?.stateabbreviation || "";
        const response = await axios.post(
          "https://api.usfarmdata.org/capstone/capstone_geo_filter?operation=getmetrolist",
          {
            state: stateAbbr,
            type: "",
          }
        );

        const apiData = response.data.metros || [];

        setOptions(apiData);
        setMetroStateOptions(apiData);
      } catch (error) {
        console.error("Failed to fetch metro options:", error);
        setOptions([]);
        setMetroStateOptions([]);
      } finally {
        setLoading(false);
      }
    };

    if (selectedState) {
      fetchMetroOptions();
    } else {
      setOptions([]);
      setMetroStateOptions([]);
    }
  }, [selectedState]);

  // Metro auto-selection is disabled - only state is auto-selected from IP
  // Users must manually select metro
  // This useEffect is kept for potential future use but currently disabled
  // useEffect(() => {
  //   if (options.length > 0 && selectedState && !selected && !userSelectedMetro && shouldAutoSelectMetro) {
  //     setSelected(options[0]);
  //     setShouldAutoSelectMetro(false);
  //   }
  // }, [options, selectedState, selected, userSelectedMetro, shouldAutoSelectMetro]);

  useEffect(() => {
    const fetchStateOptions = async () => {
      try {
        const response = await axios.post(
          "https://api.usfarmdata.org/capstone/capstone_geo_filter?operation=getstatelist",
          {
            data: {
              statename: "",
              stateabbreviation: "",
            },
          }
        );

        const apiData = response.data.states || [];
        setStateOption(apiData);
        setState(apiData);
      } catch (error) {
        console.error("Failed to fetch metro options:", error);
        setStateOption([]);
        setState([]);
      }
    };

    fetchStateOptions();
  }, []);

  const fetchCount = async () => {
    if (!selectedState || !selected) {
      setCount(null);
      return;
    }
    
    try {
      const response = await axios.post(
        "https://api.usfarmdata.org/capstone/business_count",
        {
          USFD: {
            business: {
              dedupe: "Address",
              geography: {
                metroStates: [
                  {
                    state: selectedState.stateabbreviation,
                    metros: [selected.code],
                  },
                ],
              },
              type: "count",
            },
          },
        }
      );
      console.log(response, "res");

      const apiData = response.data || [];
      setCount(apiData?.data?.count);
    } catch (error) {
      console.error("Failed to fetch count:", error);
      setCount(null);
    }
  };

  useEffect(() => {
    if (selected && selectedState) {
      fetchCount();
    }
  }, [selected, selectedState]);

  console.log(stateOption, "stateoption");  

  const data = [
    { state: "Arkansas", records: "5,002 Records", price: "$50" },
    { state: "Mississippi", records: "9,120 Records", price: "$75" },
  ];

  const balanceDue = "$125";

  console.log(selectedStateName,'selectedSTateName');

// Clear metro when state changes
const prevStateAbbrRef = React.useRef(null);

useEffect(() => {
  const currentStateAbbr = selectedState?.stateabbreviation;
  
  // Clear metro if state actually changed (different state abbreviation)
  if (selectedState && prevStateAbbrRef.current && prevStateAbbrRef.current !== currentStateAbbr) {
    setSelected(null); // Clear metro when state changes
    setSelectedStateName(''); // Clear the name choice
    setUserSelectedMetro(false); // Reset metro selection flag for new state
    setShouldAutoSelectMetro(false); // Don't auto-select metro when state is manually changed
    
    // If user manually changed state, mark it so we don't auto-select metro
    if (userChangedState) {
      setUserChangedState(false); // Reset flag after clearing
    }
  }
  
  // Also clear metro if state is cleared (set to null)
  if (!selectedState && prevStateAbbrRef.current) {
    setSelected(null);
    setSelectedStateName('');
    setUserSelectedMetro(false);
    setShouldAutoSelectMetro(false);
    prevStateAbbrRef.current = null;
  }
  
  // Update ref with current state
  if (currentStateAbbr) {
    prevStateAbbrRef.current = currentStateAbbr;
  }
}, [selectedState, userChangedState]);

// Note: Removed the conflicting useEffect that was clearing selectedState
// when selectedStateName was set, as this was interfering with state selection

// Auto-select state based on IP when page loads (only once, as default)
useEffect(() => {
  if (ip && stateOption.length > 0 && !selectedState && !isAutoSelected) {
    // ipinfo.io returns region (abbreviation) and regionName (full name)
    const ipRegion = ip.region || "";
    const ipRegionName = ip.regionName || "";
    
    const match = stateOption.find(
      (opt) =>
        opt.stateabbreviation.toLowerCase() === ipRegion.toLowerCase() || 
        opt.statename.toLowerCase() === ipRegion.toLowerCase() ||
        opt.statename.toLowerCase() === ipRegionName.toLowerCase()
    );
    
    if (match) {
      setSelectedState(match);  // store full state object
      setIsAutoSelected(true); // Mark that auto-selection has happened
      // Don't auto-select metro - only auto-select state from IP
      // This will automatically trigger metro list fetch via the useEffect above
    }
  }
}, [ip, stateOption, selectedState, isAutoSelected]);

  return (
    <div className="max-w-5xl mx-auto py-16 p-4">
      {/* Custom Styled Tabs */}
      <div className="flex">
        {tabs.map((tab) => (
          <div
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={classNames(
              "cursor-pointer px-6 md:px-12 py-2 md:py-3 font-semibold text-base md:text-lg mr-4 rounded-t-sm",
              {
                "bg-[#F09900] text-white": activeTab === tab.key,
                "bg-gray-200 text-gray-700": activeTab !== tab.key,
              }
            )}
          >
            {tab.label}
          </div>
        ))}
      </div>

      {/* Tab Content */}
      {activeTab === "state" && (
        <div className="bg-[#F8F8F8] ">
          <div className="flex flex-col md:flex-row gap-4 p-8">
            <div className="flex flex-col lg:flex-row gap-6">
              {/* Left Section - Radio & Button */}
              <div className="lg:w-[35%] w-full flex flex-col justify-between">
                {/* Radio buttons */}
                <div>
                  <label className="inline-flex items-center">
                    {/* <input type="radio" name="stateOption" className="form-radio text-orange-500" defaultChecked /> */}
                    <span className="ml-2 text-gray-800">
                      Choose by state(s)
                    </span>
                  </label>
                  <div className="mt-4 mr-12">
                    <Select
                      value={selectedState?.stateabbreviation || undefined} // show the label
                      onChange={(value) => {
                        if (value) {
                          const selected = stateOption.find(
                            (opt) => opt.stateabbreviation === value
                          );
                          if (selected) {
                            // Set state synchronously to ensure Select displays the value
                            setSelectedState(selected); // store full object
                            setSelectedStateName(selected?.statename); // also store name for compatibility
                            setUserChangedState(true); // Mark that user manually changed state
                          } else {
                            console.warn('State not found:', value);
                          }
                        } else {
                          setSelectedState(null);
                          setSelectedStateName('');
                          setSelected(null);
                          setUserChangedState(true);
                        }
                      }}
                      className="w-full"
                      placeholder="Select a state"
                      showSearch
                      allowClear
                      filterOption={(input, option) =>
                        (option?.children?.toLowerCase() ?? '').includes(input.toLowerCase())
                      }
                    >
                      {stateOption.map((option) => (
                        <Option
                          key={option.stateabbreviation}
                          value={option.stateabbreviation}
                        >
                          {option.statename}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </div>
              </div>

              <div className="grid grid-col-2">
                <div className="w-full lg:h-56 md:h-72 w-40 rounded-md lg:flex items-center justify-center text-white font-semibold text-lg">
                  <img src={map} />
                  <img src={aslkahawaii} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === "metro" && (
        <div className="bg-[#F8F8F8] p-6">
            <div>
                  <label className="inline-flex items-center">
                    {/* <input type="radio" name="stateOption" className="form-radio text-orange-500" defaultChecked /> */}
                    <span className="ml-2 text-gray-800">
                      Choose by state(s)
                    </span>
                  </label>
                  <div className="mt-4 mr-12 max-w-48">
                    {/* <Select
                      value={selectedState?.stateabbreviation} // show the label
                      onChange={(value) => {
                        const selected = stateOption.find(
                          (opt) => opt.stateabbreviation === value
                        );
                        setSelectedState(selected); // store full object
                      }}
                      className="w-full"
                      placeholder="Select a state"
                      showSearch
                    >
                      {stateOption.map((option) => (
                        <Option
                          key={option.stateabbreviation}
                          value={option.stateabbreviation}
                        >
                          {option.statename}
                        </Option>
                      ))}
                    </Select> */}
                    <Select
                      value={selectedState?.stateabbreviation || undefined}
                      onChange={(value) => {
                        if (value) {
                          const selected = stateOption.find(
                            (opt) => opt.stateabbreviation === value
                          );
                          if (selected) {
                            setSelectedState(selected); // user-chosen state
                            setUserChangedState(true); // Mark that user manually changed state
                          }
                        } else {
                          setSelectedState(null);
                          setSelected(null);
                          setUserChangedState(true);
                        }
                      }}
                      className="w-full"
                      placeholder="Select a state"
                      showSearch
                      allowClear
                      filterOption={(input, option) =>
                        (option?.children?.toLowerCase() ?? '').includes(input.toLowerCase())
                      }
                    >
  {stateOption.map((option) => (
    <Option key={option.stateabbreviation} value={option.stateabbreviation}>
      {option.statename}
    </Option>
  ))}
</Select>

                  </div>
                </div>
          <div className="my-5">
            <p className="text-gray-800">Choose by Metro(s)</p>
          </div>

          {loading ? (
            <Spin />
          ) : (
            <Radio.Group
              onChange={(e) => {
                const metroValue = e.target.value ? JSON.parse(e.target.value) : null;
                setSelected(metroValue);
                setUserSelectedMetro(true); // Mark that user manually selected metro
              }}
              value={selected ? JSON.stringify(selected) : undefined}
              className="w-full"
            >
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2">
                {options.map((option) => (
                  <Radio key={option.code} value={JSON.stringify(option)}>
                    {option.metro}
                  </Radio>
                ))}
              </div>
            </Radio.Group>
          )}
          
          {/* Show metro response when a metro is selected */}
          {selected && selectedState && (
            <div className="mt-6 p-4 bg-white rounded-lg border border-gray-200">
              <p className="font-medium text-lg mb-2">Selected Metro Details:</p>
              <div className="space-y-2">
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">Metro:</span>
                  <span className="font-semibold">{selected.metro}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">State:</span>
                  <span className="font-semibold">{selectedState.statename}</span>
                </div>
                {count !== null && count !== undefined && (
                  <div className="flex justify-between items-center">
                    <span className="text-gray-700">Records:</span>
                    <span className="font-semibold text-[#F09900]">{count} Records</span>
                  </div>
                )}
                {loading && count === null && (
                  <div className="flex justify-center py-2">
                    <Spin size="small" />
                    <span className="ml-2 text-gray-600">Loading count...</span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}

      {activeTab === "details" && (
        <div className="bg-[#F8F8F8] p-6">
          <div className="mb-12 w-[100%] md:w-[40%]">
            <p className="font-medium text-lg mb-2">Item:</p>
            <div className="flex justify-between text-sm mb-1">
              <span>{selected?.metro}</span>
              <span>{count} Records</span>
              <span>$ 50</span>
            </div>
          </div>

          <div className="flex justify-between items-center text-lg font-medium mb-6 w-[100%] md:w-[40%]">
            <span>Balance Due:</span>
            <span>{balanceDue}</span>
          </div>

          <div className="text-center md:text-left">
            <button
              className="bg-[#F09900] hover:bg-orange-600 text-white font-bold py-3 px-12 rounded shadow cursor-pointer"
              style={{ color: "white" }}
            >
              Submit
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Tab;
